/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import ContentTypography from 'components/Common/ContentTypography';
import FormField from 'components/pages/SignIn/Widgets/FormField';
import Styles from './index.module.css';

export default function TextField({
  title,
  value,
  onChange,
  disabled,
  type,
  autoComplete,
  className,
  pattern,
  inputProps,
  name,
  ...props
}) {
  const id = `registration-${title}`;
  return (
    <div className={Styles.mainContainer} {...props}>
      <label htmlFor={id} className={Styles.inputLabel}>
        <ContentTypography>{title}</ContentTypography>
      </label>
      <div className={Styles.inputField}>
        <FormField
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoComplete={autoComplete}
          pattern={pattern}
          name={name}
          {...inputProps}
        />
      </div>
    </div>
  );
}

TextField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  inputProps: PropTypes.object,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  pattern: PropTypes.string,
  name: PropTypes.string,
};

TextField.defaultProps = {
  title: '',
  value: '',
  onChange: () => {},
  disabled: false,
  type: 'text',
  autoComplete: null,
  inputProps: {},
  className: '',
  pattern: null,
  name: '',
};
